import React from 'react';
import ShimmerBlock from './shimmer-block';

const RATING_PLACEHOLDERS = [0, 1, 2, 3, 4];

// Placeholder for a screen inside the card: title, question, rating row, button.
const FeedbackBodyShimmer = () => (
  <div className="px-5 py-6 flex flex-col gap-6" aria-busy="true" aria-live="polite">
    <div className="flex flex-col gap-2">
      <ShimmerBlock width="70%" height="20px" />
      <ShimmerBlock width="90%" height="14px" />
    </div>
    <div className="flex justify-center gap-1.5">
      {RATING_PLACEHOLDERS.map((item) => (
        <ShimmerBlock key={item} width="28px" height="28px" radius="50%" />
      ))}
    </div>
    <ShimmerBlock width="100%" height="44px" radius="8px" />
  </div>
);

export default FeedbackBodyShimmer;
